import { handleApiResponse } from '@src/api/apiClient/axiosClient.ts';
import { tenantAuthStatusApiClient } from '@src/api/tenant/auth/tenantAuthStatusApiClient.ts';
import { tenantLogoutApiClient } from '@src/api/tenant/auth/tenantLogoutApiClient.ts';
import { fetchTenantUserProfile } from '@src/context/auth/ProfileFetcher';
import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { TENANT_URL } from '@src/routes/tenant';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function TenantLogout() {
  const navigate = useNavigate();
  const tenantAuth = useTenantAuth();

  useEffect(() => {
    const checkLoginStatus = async () => {
      const res = await tenantAuthStatusApiClient.status();
      handleApiResponse(res, (data) => {
        if (!data.is_login) {
          throw new Error('User is not logged in');
        }
      });
    };

    checkLoginStatus()
      .then(async () => {
        await tenantLogoutApiClient.logout();
        await fetchTenantUserProfile(tenantAuth.setProfile);
      })
      .catch((error) => console.error('Logout error:', error))
      .finally(() => navigate(TENANT_URL.HOME));
  }, [navigate]);

  return '';
}

export default TenantLogout;
